'use client';

import type { ReactNode } from 'react';

export default function QwikFixToggle({
  icon,
  label,
  sub,
  value,
  onChange,
  onLight = false,
}: {
  icon: ReactNode;
  label: string;
  sub: string;
  value: boolean;
  onChange: (next: boolean) => void;
  onLight?: boolean;
}) {
  return (
    <button
      type='button'
      role='switch'
      aria-checked={value}
      aria-label={label}
      onClick={() => onChange(!value)}
      className={
        onLight
          ? 'flex min-w-0 cursor-pointer select-none items-center gap-2.5 rounded-lg border border-[#42b9db]/20 bg-white px-2.5 py-2 text-left transition-colors hover:border-[#42b9db]/35 hover:bg-[#f8fcfe]'
          : 'flex min-w-0 cursor-pointer select-none items-center gap-2.5 rounded-lg border border-white/10 bg-black/20 px-2.5 py-2 text-left transition-colors hover:border-white/15 hover:bg-black/30'
      }
    >
      <div className='grid h-[26px] w-[26px] shrink-0 place-items-center rounded-md bg-[#42b9db]/15 text-[#027B9F]'>
        {icon}
      </div>
      <div className='min-w-0 flex-1'>
        <p
          className={`text-xs font-semibold leading-tight ${onLight ? 'text-[#00394d]' : 'text-white'}`}
        >
          {label}
        </p>
        <p
          className={`mt-0.5 text-[10.5px] leading-snug ${onLight ? 'text-default-500' : 'text-white/55'}`}
        >
          {sub}
        </p>
      </div>
      <span
        className={`relative h-[17px] w-[30px] shrink-0 rounded-full transition-colors ${
          value ? 'bg-[#42b9db]' : onLight ? 'bg-default-200' : 'bg-white/15'
        }`}
        aria-hidden
      >
        <span
          className={`absolute top-0.5 left-0.5 h-[13px] w-[13px] rounded-full bg-white shadow transition-transform ${
            value ? 'translate-x-[13px]' : 'translate-x-0'
          }`}
        />
      </span>
    </button>
  );
}
